import React from "react";
import { Phone, ClipboardList } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { COMPANY } from "../lib/site";
import { useLang } from "../i18n/LanguageContext";
import { useEffect, useRef, useState } from "react";

export default function MobileStickyBar() {
  const { t } = useLang();
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    setHidden(false);
    const el = document.getElementById("footer-sentinel"); ref.current = el;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver((entries) => entries.forEach(e => setHidden(e.isIntersecting)), { rootMargin: "0px 0px -20px 0px", threshold: 0 });
    io.observe(el);
    return () => io.disconnect();
  }, [pathname]);
  if (pathname.startsWith("/admin")) return null;
  return (
    <div className={`mobile-sticky lg:hidden transition-transform duration-300 ${hidden ? "translate-y-[110%] pointer-events-none opacity-0" : "translate-y-0 opacity-100"}`} aria-hidden={hidden} data-testid="mobile-sticky-bar">
      <a href={`tel:${COMPANY.phoneClean}`} className="btn-primary w-full !py-3 text-sm" data-testid="sticky-call-btn"><Phone size={16} /> {t("sticky.call")}</a>
      <Link to="/be-om-pristilbud" className="btn-secondary w-full !py-3 text-sm" data-testid="sticky-quote-btn"><ClipboardList size={16} /> {t("sticky.quote")}</Link>
    </div>
  );
}
